import { IconButton, IconClose24, ModalFullscreen, RoundButton, UIHeading1, UIHeading2, UIText1 } from '@cian/ui-kit';
import { useBooleanState } from '@cian/react-utils';

import { FC } from 'react';

import styles from './InvestmentSlide.css';
import { IconMediaPlayArrow16 } from '@cian/ui-kit-design-tokens/icons';
import { calculateVideoDimensions } from '../../utils/calculateVideoDimensions';

type VideoSource = {
  src: string;
  type: string;
};

type Video = {
  poster: string;
  sources: VideoSource[] & [VideoSource];
};

export type InvestmentSlideProps = {
  investorShortStory: string;
  investorInfo: string;
  investorStory: string;
  video: Video;
};

export const InvestmentSlide: FC<InvestmentSlideProps> = ({
  investorInfo,
  investorShortStory,
  investorStory,
  video,
}) => {
  const modalState = useBooleanState();

  return (
    <>
      <div className={styles['container']} data-testid="InvestmentSlide">
        <div className={styles['content']}>
          <UIText1>Люди, которые уже инвестируют в квартиры от ПИК</UIText1>
          <div>
            <div className={styles['content-heading']}>
              <UIHeading2>{investorShortStory}</UIHeading2>
              <UIHeading2 color="text-warning-default">{investorInfo}</UIHeading2>
            </div>
            <UIText1>{investorStory}</UIText1>
          </div>
        </div>
        <div
          className={styles['video-preview-container']}
          data-testid="video-preview-container"
          onClick={modalState.setTrue}
        >
          <img src={video.poster} height="100%" width="100%" className={styles['video-preview']} />

          <div className={styles['play-button-wrapper']}>
            <RoundButton theme="fill_light" title="Воспроизвести" icon={<IconMediaPlayArrow16 />} />
          </div>
        </div>
      </div>
      <ModalFullscreen open={modalState.state} theme="white" onClose={modalState.setFalse}>
        {modalState.state && (
          <div className={styles['modal-container']} data-testid="InvestmentSlide--modal-container">
            <div className={styles['modal-heading']}>
              <div className={styles['heading-text']}>
                <UIHeading1 data-testid="InvestmentSlide--modal-heading-text">{investorInfo}</UIHeading1>
              </div>
              <IconButton
                data-testid="InvestmentSlide--modal-close-button"
                icon={<IconClose24 />}
                onClick={modalState.setFalse}
              />
            </div>
            <video
              data-testid="InvestmentSlide--modal-video"
              style={{
                ...calculateVideoDimensions(
                  window.innerWidth - 80, // Минус отступы модального окна
                  window.innerHeight - 40 - 36 - 12, // Минус отступы модального окна, шапки модального окна и отступа шапки и видео
                ),
              }}
              autoPlay
              controls
              className={styles['video']}
            >
              {video.sources.map(({ src, type }) => (
                <source key={`${src}_${type}`} src={src} type={type} />
              ))}
            </video>
          </div>
        )}
      </ModalFullscreen>
    </>
  );
};
